export default __webpack_public_path__ + "locales/de/Settings.json?hash=3a6e290da976381156428ffa93e072c5";